import { BluetoothRawOption } from "@/utils/bluetooth";
import { NOTIFY as ICC_NOTIFY } from "./icc";
/* 
service: 0x2024 ~ 0x2028
0x2024特征：0x6601~660A
0x2025特征：0x6701~670A
0x2026特征：0x6801~680A
0x2027特征：0x6901~690A
0x2028特征：0x6A01~6A0A

*/
export const OUTPUT = {
  name: "output",
  uuid: 0x6601,
  properties: ["read", "write", "notify"],
};

export const HEARTBEAT = {
  name: "heartbeat",
  uuid: 0x7001,
  properties: ["read", "write", "notify"],
};

export const SERVICE = {
  name: "SERVICE",
  uuid: 0x2024,
  characteristics: [OUTPUT, ICC_NOTIFY], // This is not required
};
export const SERVICE_OTA_UPDATE = {
  name: "SERVICE",
  uuid: 0x2023,
  characteristics: [],
};

// 蓝牙元数据 
export const ESP32BLE = {
  name: "xcu_ble",
  services: [SERVICE],
} as BluetoothRawOption;

export const ESP32BLE_OTA_UPDATE = {
  name: "ota_xcu_ble",
  services: [SERVICE_OTA_UPDATE],
} as BluetoothRawOption;
